import { Page } from '../types'
import Architecture from '../../logic/Architecture'

type SummaryProps = {
    architecture: Architecture
}

const render = ({ architecture } : SummaryProps) => {
    return <>
        <ul>
            {architecture.bricks.map(brick => <li key={brick.key()}>{brick.describe()}</li>)}
        </ul>
    </>
}


const ArchitectureSummary : Page<SummaryProps> = { key: 'architecture-summary', title: 'Architecture summary', render }

export default ArchitectureSummary